export const useClsUtil_09 = () => {
  const getCls01 = () => {
    // 基础样式
    let classes = "p-16 backdrop-blur-10";

    classes += " bg-[var(--app-bg-08)] rounded-10";
    return classes;
  };

  const getCls02 = () => {
    const baseClasses = "w-full flex justify-start items-center gap-x-0 p-[15px_0]";

    return `${baseClasses} border-b-1 border-solid border-b-[var(--app-border-06)] last:border-none`;
  };
  const getCls03 = () => {
    const baseClasses = ["color-[var(--app-text-04)]"];

    baseClasses.push("font-400", "text-12");

    return baseClasses;
  };
  const getCls04 = () => {
    return ["w-25", "block", "mt-0"];
  };
  const getCls05 = () => {
    const baseClasses = ["color-[var(--app-text-04)]"];

    baseClasses.push("font-400", "text-12", "text-left");

    return baseClasses;
  };
  const getCls06 = () => {
    const baseClasses = ["color-[var(--app-text-04)]"];

    return baseClasses;
  };
  const getCls07 = () => {
    const baseClasses = [
      "block",
      "m-[15px_auto_5px_auto]",
      "w-100%",
      "bg-[var(--app-bg-18)]",
      "text-center",
      "color-[var(--app-text-04)]",
      "decoration-none",
    ];

    baseClasses.push("font-500", "text-14", "lh-35", "rounded-10");

    return baseClasses;
  };
  return { getCls01, getCls02, getCls03, getCls04, getCls05, getCls06, getCls07 };
};
